import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, FormHelperText } from '@mui/material';
import { AdminDialogProps } from './type';
import { COLORS_ADMIN_PAGE } from '../conf/constants';

const AdminDialog: React.FC<AdminDialogProps> = ({
  isFormOpen,
  setIsFormOpen,
  selectedAdmin,
  formData,
  handleFormChange,
  handleFormSubmit,
}) => {
  const [errors, setErrors] = useState({
    username: '',
    email: '',
    password: '',
    firstName: '',
    lastName: '',
  });

  const validateForm = () => {
    const newErrors = {
      username: formData.username.trim() ? '' : 'Username is required',
      email: formData.email.trim() ? '' : 'Email is required',
      password:
        selectedAdmin || formData.password.trim() ? '' : 'Password is required when creating a new admin',
      firstName: formData.firstName.trim() ? '' : 'First Name is required',
      lastName: formData.lastName.trim() ? '' : 'Last Name is required',
    };
    return newErrors;
  };

  const isFormValid = () => {
    return (
      formData.username.trim() &&
      formData.email.trim() &&
      formData.firstName.trim() &&
      formData.lastName.trim() &&
      (selectedAdmin || formData.password.trim())
    );
  };

  const onSubmit = () => {
    const newErrors = validateForm();
    if (isFormValid()) {
      handleFormSubmit();
      setErrors({ username: '', email: '', password: '', firstName: '', lastName: '' }); 
    } else {
      setErrors(newErrors); 
    }
  };

  return (
    <Dialog open={isFormOpen} onClose={() => setIsFormOpen(false)}>
      <DialogTitle>{selectedAdmin ? 'Edit Admin' : 'Create New Admin'}</DialogTitle>
      <DialogContent>
        <TextField
          label="Username"
          name="username"
          value={formData.username}
          onChange={handleFormChange}
          fullWidth
          margin="normal"
          required
          error={!!errors.username}
          helperText={errors.username}
        />
        <TextField
          label="Email"
          name="email"
          value={formData.email}
          onChange={handleFormChange}
          fullWidth
          margin="normal"
          required
          error={!!errors.email}
          helperText={errors.email}
        />
        {!selectedAdmin && (
          <TextField
            label="Password"
            name="password"
            type="password"
            value={formData.password || ''}
            onChange={handleFormChange}
            fullWidth
            margin="normal"
            required
            error={!!errors.password}
            helperText={errors.password}
          />
        )}
        <TextField
          label="First Name"
          name="firstName"
          value={formData.firstName}
          onChange={handleFormChange}
          fullWidth
          margin="normal"
          required
          error={!!errors.firstName}
          helperText={errors.firstName}
        />
        <TextField
          label="Middle Name"
          name="middleName"
          value={formData.middleName}
          onChange={handleFormChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Last Name"
          name="lastName"
          value={formData.lastName}
          onChange={handleFormChange}
          fullWidth
          margin="normal"
          required
          error={!!errors.lastName}
          helperText={errors.lastName}
        />
        <TextField
          label="Phone Number"
          name="phoneNumber"
          value={formData.phoneNumber}
          onChange={handleFormChange}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setIsFormOpen(false)} sx={{ color: COLORS_ADMIN_PAGE.PRIMARY }}>
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          sx={{ color: COLORS_ADMIN_PAGE.PRIMARY }}
          disabled={!isFormValid()}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdminDialog;